<template>
  <section class="page-container">
    <div class="top-bar">
      <span>plan</span>
    </div>
    <div class="main-container">

      <div
        class="main-edit flex-1">
        <div class="top-header">
          <div class="card width-250">
            <div class="card-padding">
              <p class="title">Insurer Profile</p><br>
              <p class="title">Manulife</p>
              <div class="flex flex-1">
                <span>Plans</span>
                <span>12</span>
              </div>
            </div>
            <div class="hr-line"></div>
            <div class="btn-list card-padding">
              <v-button
                size="small"
                type="primary"
                plain
                @click="handlerInsurer">View Insurer
              </v-button>
            </div>
          </div>
          <div class="card flex-1">
            <div class="info-container">
              <div class="info-header">
                <div>
                  <img
                    src=""
                    alt="">
                  <span class="plan-title">SmartChoice Motorcycle+ Scooters Third-Party Plan</span>
                </div>
              </div>
              <div class="hr-line"></div>
              <div class="info-content">
                <div>
                  <span class="label">Insurance Type</span>
                  <span>{{ detailData.product_language }}</span>
                </div>
                <div>
                  <span class="label">Plan No.</span>
                  <span>{{ detailData.product_language }}</span>
                </div>
                <div>
                  <span class="label">Issued On</span>
                  <span>
                    {{ detailData.created_at }}
                  </span>
                </div>
                <div>
                  <span class="label">Last Updated</span>
                  <span>
                    {{ detailData.updated_at }}
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div v-if="showPlanForm">
        <plan-form></plan-form>
      </div>
      <div v-else>
        <div class="flex flex-sb-center">
          <h2 >Notice/News</h2>
          <v-button @click="handlerAdd">Manage Notice/News</v-button>
        </div>
        <div class="form-item">
          <!--        <div>-->
          <span>2020-03-04</span>
          <span class="margin-bottom">Nam fermentum urna quis eros gravida, eu tincidunt dolor mollis. Mauris sed facilisis erat. Etiam a massa quis est ultricies facilisis efficitur auctor dolor. Integer sagittis odio sit amet enim volutpat, vel sagittis sapien tempor. In porta lorem nisi, sed pulvinar odio ullamcorper eget. Cras vel libero tempus, scelerisque elit vel, blandit nisl. Cras leo neque, hendrerit eget augue nec, congue egestas arcu. Vestibulum velit ex, malesuada sodales blandit nec, maximus malesuada enim. Pellentesque finibus lacus tellus, nec congue augue porttitor sit amet. Fusce diam libero, vulputate sed purus et, suscipit porta velit. Fusce et orci enim.
            Text Style</span>
          <!--        </div>-->
          <file-container />
          <span>2020-03-04</span>
          <span class="margin-bottom">Nam fermentum urna quis eros gravida, eu tincidunt dolor mollis. Mauris sed facilisis erat. Etiam a massa quis est ultricies facilisis efficitur auctor dolor. Integer sagittis odio sit amet enim volutpat, vel sagittis sapien tempor. In porta lorem nisi, sed pulvinar odio ullamcorper eget. Cras vel libero tempus, scelerisque elit vel, blandit nisl. Cras leo neque, hendrerit eget augue nec, congue egestas arcu. Vestibulum velit ex, malesuada sodales blandit nec, maximus malesuada enim. Pellentesque finibus lacus tellus, nec congue augue porttitor sit amet. Fusce diam libero, vulputate sed purus et, suscipit porta velit. Fusce et orci enim.
            Text Style</span>
        </div>
        <h2 >Policy Wording</h2>
        <div class="form-item">
          <file-container />
        </div>
        <h2 >Brochure</h2>
        <div class="form-item">
          <file-container />
          <file-container />
        </div>
      </div>
    </div>


  </section>
</template>

<script>
import {
  getCarQuoteDetail,
  getHousemaidQuoteDetail,
  getInteriorQuoteDetail,
  getHomefireQuoteDetail,
  orderCsSet
} from '@api/quote'
import NewGeneralTicket from '@/views/tickets/dialogs/new-general-ticket'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import planForm from './components/plan-form'
import {mapActions,mapState} from 'vuex'

export default {
  name: 'planInfo',
  components:{
    planForm
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    form:{
      type:Object,
      default:()=>({})
    }
  },
  data() {
    return {
      detailData: {
        customer: {},
      },
      activeTab: '0',
      remarkList: [],
      message: '',
      showPlanForm:false
    }
  },
  computed: {
    ...mapState('quote',['isBack']),
    productId() {
      return this.$route.query.product_id || 11
    },
    orderId() {
      return this.$route.query.order_id
    },
    customerId() {
      const { customer_id} = this.form
      return customer_id
    },
    showVoidQuoteBtn() {
      return this.form.stts != 0
    },
    disabledBuyQuoteBtn() {
      return this.form.stts == 0
    },
    disabledCopyBtn() {
      return this.form.stts == 0
    }
  },
  created() {
  },
  methods: {
    ...mapActions('common', ['setProductId']),
    ...mapActions('coupon', ['setCouponData']),
    handlerInsurer(){
      this.$router.push({
        path: '/insurer/accounts',
        query: {
          id: this.form.plan_id
        }
      })
    },
    handlerAdd(){
      this.showPlanForm = true
    },
    network() {
      return {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  padding: 20px 30px;
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }
  .main-container {
    //display: flex;
    //justify-content: space-between;
    margin: 20px auto 0 auto;

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          //width: 250px;
        }
        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }
        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }

    .card{
      padding: 0;
      .hr-line{
        height: 1px;
        background: #DDDFE7 ;
      }
      .padding-top-bottom{
        padding: 16px 0;
      }
      &.width-250{
        width: 250px;
      }
    }
    .card-padding{
      padding: 16px;
      .flex-1{
        span{
          flex: 1;
        }
      }
    }
    .info-container {
      color: #616266;
    .info-header{
      .plan-title{
        font-size: 24px;
        font-weight: bold;
        margin-left: 16px;
      }
      padding: 16px;
    }

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        padding: 16px;
        justify-content: space-between;
        padding: 16px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

  }
    .form-item{
      .margin-bottom{
        font-weight: normal;
      }
      span{
        display: block;
        padding-bottom: 5px;
        font-size: 16px!important;
        font-weight: 500;
        color: #616266!important;
      }
    }
}
</style>